import axios from 'axios'
import { Toast } from 'vant'

const BASE_URL = 'https://www.wanfangtest.com/api/v1'

const ajax = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
})

let toastInstance = null

function isWechatBrowser() {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

function buildBlankpageRedirectUrl() {
  const currentUrl = new URL(window.location.href)
  const currentPath = currentUrl.pathname.replace(/^\/p/, '') || '/'
  const params = new URLSearchParams(currentUrl.search)

  params.delete('code')
  params.delete('state')
  params.delete('appid')
  params.delete('scope')

  const redirectParams = new URLSearchParams()
  redirectParams.set('currentpath', currentPath)

  params.forEach((value, key) => {
    redirectParams.append(key, value)
  })

  return `/p/blankpage?${redirectParams.toString()}`
}

function getToken() {
  return window.sessionStorage.getItem('Token') || ''
}

function getAuthHeaders(extraHeaders = {}) {
  const token = getToken()

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  }
}

ajax.interceptors.request.use(
  config => {
    if (!config.silent) {
      toastInstance = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '加载中...'
      })
    }

    config.headers = {
      ...(config.headers || {}),
      ...getAuthHeaders(config.headers || {})
    }

    return config
  },
  error => Promise.reject(error)
)

ajax.interceptors.response.use(
  response => {
    if (toastInstance) {
      toastInstance.clear()
      toastInstance = null
    }

    return response.data
  },
  error => {
    if (toastInstance) {
      toastInstance.clear()
      toastInstance = null
    }

    const message =
      error &&
      error.response &&
      error.response.data &&
      (error.response.data.message || error.response.data.error)

    const skipErrorToast =
      error &&
      error.config &&
      error.config.skipErrorToast

    if (error && error.response && error.response.status === 401) {
      window.sessionStorage.removeItem('Token')
      window.sessionStorage.removeItem('user')
      window.sessionStorage.removeItem('username')
      window.sessionStorage.removeItem('nick_name')
      window.sessionStorage.removeItem('avatar')

      if (isWechatBrowser() && window.location.pathname !== '/p/blankpage') {
        window.location.replace(buildBlankpageRedirectUrl())
        return Promise.reject(error)
      }
    } else if (message && !skipErrorToast) {
      Toast.fail(message)
    }

    return Promise.reject(error)
  }
)

export const getToLogin = data => ajax.post('/authorizations', data)

export const getjcList = () => ajax.get('/categories', { silent: true })

export const getToUpload = data => ajax.post('/orders', data)

export const getTopaste = data => ajax.post('/orders', data)

export const getReport = page => ajax.get(`/orders?page=${page}`)

export const getOrderDetail = id => ajax.get(`/orders/${id}`)

export const getToRegister = data => ajax.post('/users', data)

export const getCode = data => ajax.post('/verificationCodes', data)

export const getToEmail = (id, params) => ajax.post(`/orders/${id}/mail_report`, params)

export const getFileId = data =>
  ajax.post('/files', data, {
    headers: {
      'content-type': 'multipart/form-data;charset=UTF-8',
    }
  })

export const getQrCode = data =>
  ajax.get(
    `/qcrode/generate_img?title=${data.title}&writer=${data.writer}&category_name=${data.bbname}&created_at=${data.tjtime}&rate=${data.rate}`
  )

export const getTowxPay = data =>
  ajax.get(`/payments/${data.id}/bridge_data?openid=${data.openid}&code=${data.code}${data.duplicate_confirmed ? '&duplicate_confirmed=1' : ''}`, {
    skipErrorToast: true,
  })

export const getOpenId = data =>
  ajax.get(`/payments/get_openid?code=${data.code}`)

export const getLogin = data =>
  ajax.post('/socials/wechat/authorizations', data)

export const getNoLoginOrder = phone =>
  ajax.get(`/mini-orders?phone=${phone}`, { silent: true })

export const getNoQrCode = data =>
  ajax.get(
    `/qcrode/min-generate-img?title=${data.title}&writer=${data.writer}&category_name=${data.bbname}&created_at=${data.tjtime}&rate=${data.rate}`,
    { silent: true }
  )

export const getNoToEmail = (id, params) => ajax.post(`/orders/${id}/send-mail`, params)

export const deleteOrder = id => ajax.delete(`/orders?ids[]=${id}`)

export const getIsPhone = orderid => ajax.get(`/check-order/${orderid}`, { silent: true })

export const freePay = id => ajax.get(`/payments/${id}/pay-by-free`)

export const duplicatePayCheck = (id, confirmed = false) =>
  ajax.get(`/payments/${id}/duplicate-check${confirmed ? '?duplicate_confirmed=1' : ''}`, {
    skipErrorToast: true,
  })

export const isPDF = orderid =>
  ajax.get(`/pdf/${orderid}.pdf`, {
    baseURL: 'https://www.wanfangtest.com',
    headers: {
      'content-type': 'application/pdf'
    },
    silent: true
  })

export const yzOrder = params =>
  ajax.post('/verification-report', params, {
    baseURL: 'https://p.checklike.com/api/v1'
  })

export const getVipRequst = data => ajax.post('/coupon-codes/active-coupon-code', data)

export const getMyCard = id => ajax.get(`/orders/${id}/coupon_codes`)

export const getUserInfo = () => ajax.get('/user', { silent: true })

export const countPrice = (id, code) => ajax.get(`/orders/${id}/coupon-price?code=${code}`)

export const activeVip = () => ajax.get('/active-vip')

export const getCurrentTeam = () => ajax.get('/team/current', { silent: true })

export const getTeamByToken = token => ajax.get(`/team/${token}`, { silent: true })

export const createTeam = () => ajax.post('/team/create')

export const joinTeam = token => ajax.post('/team/join', { token })

export const leaveTeam = () => ajax.post('/team/leave')

export const postFrontendLog = data =>
  ajax.post('/frontend/logs', data, {
    silent: true,
    skipErrorToast: true,
  })
